import PostsSerializer from '@linc-technologies/linced-common/serializers/posts/base';
import { typeOf } from '@ember/utils';

export default class Comment extends PostsSerializer {
  serialize(snapshot) {
    let hash = super.serialize(...arguments);

    // We define authorId as a flat string, but the comment UI pushes in the
    // Person record as linced-common uses a belongsTo relationship.
    let author = snapshot.attr('authorId');
    if (typeOf(author) !== 'string') {
      hash.authorId = author.id;
    }

    return hash;
  }
}
